module.exports = __webpack_public_path__ + "static/img/master_studio_manage_3.fc717bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master_studio_manage_3.png
// module id = UT4n
// module chunks = 11